// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 引入echarts
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
Vue.use(VueAwesomeSwiper )/* { default options with global component } */

import axiosUtil from '@/assets/js/axiosUtil.js';
Vue.prototype.ajaxUtil = axiosUtil
Vue.use(ElementUI);
// 滚动条回顶部 放在`router.beforeEach`更好
router.afterEach((to, from, next)=>{
    window.scrollTo(0, 0)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js